<template>
  <v-card outlined style="border-radius: 16px">
    <v-card-title class="d-flex">
      <h2 class="mr-3">
        🥳
      </h2>
      Aniversariantes do mês
    </v-card-title>
    <v-card-text>
      <v-list v-if="customers.length" dense rounded>
        <v-list-item-group color="primary">
          <v-list-item v-for="(customer, i) in customers" :key="i" @click="sendBirthdayMessage(customer)">
            <v-list-item-icon>
              {{ formatDate(customer.birth_date) }}
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title v-text="customer.name"></v-list-item-title>
            </v-list-item-content>
            <v-list-item-action>
              <v-icon color="primary">mdi-whatsapp</v-icon>
            </v-list-item-action>
          </v-list-item>
        </v-list-item-group>
      </v-list>
      <div v-else class="d-flex flex-column align-center text-center py-4">
        <v-avatar color="#F3EFFC" size="52" class="mb-3">
          <app-icon color="primary">cake</app-icon>
        </v-avatar>
        <span class="text--secondary">Nenhum aniversariante este mês.</span>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import { format, parseISO } from "date-fns";

export default {
  data: () => ({
    customers: [],
  }),

  mounted() {
    this.$http.index("dashboards/birthdays").then((response) => {
      this.customers = response.customers;
    });
  },

  methods: {
    formatDate(birth_date) {
      return format(parseISO(birth_date), "dd/MM");
    },

    sendBirthdayMessage(customer) {


      let phone = customer.phone_wa.replace(/\D/g, '');
      let link = `https://wa.me/${phone}`;

      window.open(link);
    },
  },
};
</script>
<style></style>
